import React from 'react';
import { CloudIcon, GraphIcon, CartIcon, FactoryIcon, GearIcon } from '../components/Icons';

const SOLUTIONS = [
  {
    icon: <CloudIcon />, tag: 'Integration',
    title: 'SAP Integration Modernization',
    desc: 'Replace fragile point-to-point integrations with a reusable, API-led integration landscape on SAP BTP.',
    benefits: ['Reduced integration incidents', 'Single monitoring platform', 'Reusable iFlow & API patterns', 'Future-proof architecture'],
  },
  {
    icon: <GraphIcon />, tag: 'Architecture',
    title: 'API-Led Enterprise Architecture',
    desc: 'Build reusable APIs creating a common access layer across all business systems, eliminating direct coupling.',
    benefits: ['Reduced point-to-point complexity', 'Faster onboarding of new systems', 'API governance & lifecycle', 'Secure OAuth 2.0 access'],
  },
  {
    icon: <CartIcon />, tag: 'Retail',
    title: 'Retail Omnichannel Integration',
    desc: 'Connect orders, inventory, CRM, fulfilment and analytics across all retail channels in real-time.',
    benefits: ['Real-time inventory sync', 'Unified order management', 'Customer 360° view', '92% reduction in overselling'],
  },
  {
    icon: <FactoryIcon />, tag: 'Manufacturing',
    title: 'Manufacturing Analytics',
    desc: 'Connect shop-floor systems, ERP and supply-chain data to deliver actionable manufacturing intelligence.',
    benefits: ['Production OEE visibility', 'Quality trend analysis', 'Supply chain analytics', 'Shop-floor integration'],
  },
  {
    icon: <GearIcon />, tag: 'ERP / CRM',
    title: 'ERP & CRM Transformation',
    desc: 'Streamline sales, service, payment, dispute and case workflows with Odoo ERP/CRM automation.',
    benefits: ['55% faster response time', 'Automated case management', 'Payment operations', 'Customer self-service portal'],
  },
];

export default SOLUTIONS;
